import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { positionsActions, sessionActions } from './store';

// Quadrant owns the session and the tracking projection. Polling avoids leaking
// the provider's socket protocol or credentials to the browser.
const SocketController = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.session.user);
  useEffect(() => {
    const controller = new AbortController();
    let running = false;
    const load = async () => {
      if (running) return;
      running = true;
      try {
        const response = await fetch('/api/session', { signal: controller.signal });
        if (response.status === 401) { dispatch(sessionActions.updateUser(null)); navigate(`/login?next=${encodeURIComponent(window.location.pathname + window.location.search)}`); return; }
        if (!response.ok) throw new Error('Session unavailable');
        const session = await response.json();
        if (!user) dispatch(sessionActions.updateUser(session));
        // Roles with no tracking of their own never ask for positions. This runs before the
        // application knows who it is - it is what finds out - so it has to make the decision
        // itself, and a tyre user asking for positions gets a refusal it has no way to act on.
        if (session.role === 'PLATFORM_ADMINISTRATOR' || session.role === 'TPMS_OPERATOR') return;
        const positions = await fetch('/api/positions', { signal: controller.signal });
        if (!positions.ok) throw new Error('Tracking unavailable');
        // Replace rather than merge: this response is the whole of what this account may see, and a
        // vehicle absent from it has had its tracking withdrawn.
        dispatch(positionsActions.replace(await positions.json()));
        dispatch(sessionActions.updateSocket(true));
      } catch (error) {
        if (error.name !== 'AbortError') dispatch(sessionActions.updateSocket(false));
      } finally { running = false; }
    };
    load(); const timer = setInterval(load, 10000);
    return () => { controller.abort(); clearInterval(timer); };
  }, [dispatch, navigate, user?.id]);
  return null;
};
export default SocketController;
